import { EArticleClass, TArticleDetail } from 'shared/models/article';
import { EClickPosition } from 'shared/constant';
import { active } from '~/utils/active/active';
import { IRelatedUserDetail, IRelatedUserPost } from 'shared/models';
import { SHARING_DEFAULT_PID } from './constant';

export const getPageTypeFromArticleClass = (articleClass: EArticleClass): 'video' | 'article' | 'fizz' => {
  switch (articleClass) {
    case EArticleClass.VIDEO:
      return 'video';
    case EArticleClass.FIZZ:
      return 'fizz';
    default:
      return 'article';
  }
};

export const activeToArticle = (article: TArticleDetail, clickPosition: EClickPosition, clickId?: string): void => {
  active({
    schemaOption: {
      pid: SHARING_DEFAULT_PID,
      pageType: getPageTypeFromArticleClass(article.articleClass),
      groupId: article.groupId,
      authorId: article.author.userId,
    },
    ampExtraOption: {
      clickPosition,
      clickId,
    },
  });
};

export const activeToArticleByRelatedUserPost = (
  article: IRelatedUserPost,
  user: IRelatedUserDetail,
  clickPosition: EClickPosition,
  clickId?: string,
): void => {
  active({
    schemaOption: {
      pid: SHARING_DEFAULT_PID,
      pageType: getPageTypeFromArticleClass(article.articleClass),
      groupId: article.groupId,
      authorId: user.userId,
    },
    ampExtraOption: {
      clickPosition,
      clickId,
    },
  });
};

export const activeToArticleByMeta = (
  meta: {
    pageType: 'video' | 'article' | 'fizz';
    groupId: string;
  },
  clickPosition: EClickPosition,
  clickId?: string,
): void => {
  active({
    schemaOption: {
      pid: SHARING_DEFAULT_PID,
      pageType: meta.pageType,
      groupId: meta.groupId,
    },
    ampExtraOption: {
      clickPosition,
      clickId,
    },
  });
};
